import type { HelpFile } from '../../types/help'
import { AccessGovernanceTestIds } from '../../../testids/AccessGovernanceTestIds'

export const accessGovernanceHelp: HelpFile = {
  docPage: '/docs/governance/overview',
  texts: {
    [AccessGovernanceTestIds.accessGovernanceWelcomeCard]:
      'Startseite des Bereichs Access Governance — wählen Sie ein Werkzeug aus der Seitenleiste: Zugriffsprofile, Auto-Zuweisungsregeln, Restriktionsregeln, Anträge, Genehmigungs-Policies, Zertifizierungskampagnen und Delegationen.',
  },
}
